import { sandboxJiraPageEntryPoint } from '@jira/spa-apps__sandbox-relay/src/sandboxJiraPageEntryPoint.entrypoint.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { sandboxRelayJiraPageRoute } from '@jira/router-routes__sandbox-routes/src/sandboxRelayJiraPageRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const sandboxRelayJiraPageEntryPoint = createPageEntryPoint({
	main: sandboxJiraPageEntryPoint,
});

export const sandboxRelayJiraPageRouteEntry: Route = createEntry(sandboxRelayJiraPageRoute, () => ({
	group: 'sandbox',
	entryPoint: () => sandboxRelayJiraPageEntryPoint,
	layout: globalLayout,
	resources: [],
	ufoName: 'sandbox-relay-jirasearch',

	bifrost: {
		// WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
		// manifestName: 'jira-spa-sandboxdemo.json',
		bifrostGroup: 'not-deployed',
	},
}));
